module.exports = __webpack_public_path__ + "static/fonts/Robotoblackitalic.425a3fc.woff2";